import React from 'react';


import Logo from '../assets/Logo.png'
import BajajLogo from '../assets/bajaj_logo.webp'

function SplashPage() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '32px',
      }}>
        <img
          src={BajajLogo}
          alt="Bajaj Logo"
          style={{
            width: '200px',
            objectFit: 'contain',
            marginBottom: '24px',
          }}
        />
        <div className="loader" style={{ marginBottom: '24px' }}>
          <span style={{
            display: 'block',
            width: '40px',
            height: '40px',
            border: '5px solid #333',
            borderTop: '5px solid #fff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }} />
        </div>
        <div style={{ fontWeight: 400, fontSize: 21, opacity: 0.85 }}>
          Powered by <span style={{ color: 'red', fontWeight: 600 }}>Lumina</span>
        </div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default SplashPage;
